var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsiderThreat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1348.56 139.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.476,121.977V14.9H36.182v107.08Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,121.977H126.272L79.69,40.971h-.659q1.39,21.462,1.392,30.616v50.39H60.135V14.9H88.772l46.509,80.2h.513q-1.1-20.874-1.1-29.516V14.9H155.13Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.291,92.241q0,14.5-10.437,22.852t-29.041,8.349q-17.137,0-30.322-6.445V95.9a124.929,124.929,0,0,0,18.347,6.812,54.3,54.3,0,0,0,13.733,1.977q7.471,0,11.463-2.856t3.991-8.5a9.38,9.38,0,0,0-1.758-5.6,19.645,19.645,0,0,0-5.163-4.724,133.264,133.264,0,0,0-13.879-7.251Q189.409,71.147,184.5,66.9a33.225,33.225,0,0,1-7.837-9.887,28.209,28.209,0,0,1-2.93-13.184q0-14.21,9.632-22.339t26.623-8.13a62.832,62.832,0,0,1,15.93,1.978A109.649,109.649,0,0,1,241.778,20.9l-7.324,17.652a107.2,107.2,0,0,0-14.172-4.908,45.709,45.709,0,0,0-11.023-1.391q-6.447,0-9.888,3a9.9,9.9,0,0,0-3.442,7.837,9.7,9.7,0,0,0,1.391,5.237,15.276,15.276,0,0,0,4.431,4.32q3.039,2.09,14.392,7.508,15.013,7.179,20.582,14.393T242.291,92.241Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.7,121.977V14.9h22.7v107.08Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.2,67.412q0,26.44-15.051,40.5t-43.469,14.062H305.358V14.9h33.618q26.22,0,40.723,13.843T394.2,67.412ZM370.617,68q0-34.5-30.469-34.5H328.063v69.726h9.742Q370.616,103.227,370.617,68Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.063,121.977h-61.67V14.9h61.67V33.5H436.1V57.012h36.254v18.6H436.1v27.612h38.964Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.107,80.888v41.089H494.4V14.9h31.2q21.825,0,32.3,7.948t10.474,24.132a28.413,28.413,0,0,1-5.2,16.809,34.413,34.413,0,0,1-14.722,11.536q24.169,36.108,31.494,46.655H554.754L529.192,80.888Zm0-18.457h7.325q10.765,0,15.893-3.588t5.127-11.28q0-7.617-5.237-10.84T523.992,33.5h-6.885Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.7,121.977h-22.7V33.794H615.917V14.9h80.859v18.9H667.7Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798,121.977H775.368V75.762H732.961v46.215H710.256V14.9h22.705V56.865h42.407V14.9H798Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.731,80.888v41.089H822.026V14.9h31.2q21.825,0,32.3,7.948T896,46.977a28.413,28.413,0,0,1-5.2,16.809,34.413,34.413,0,0,1-14.722,11.536q24.17,36.108,31.494,46.655H882.378L856.816,80.888Zm0-18.457h7.325q10.765,0,15.893-3.588t5.127-11.28q0-7.617-5.237-10.84T851.616,33.5h-6.885Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.72,121.977H918.05V14.9h61.67V33.5H940.755V57.012H977.01v18.6H940.755v27.612H979.72Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.61,121.977l-7.763-25.488h-39.038l-7.764,25.488H985.582l37.793-107.519h27.759l37.939,107.519Zm-13.183-44.531Q1040.66,42.8,1039.305,38.262t-1.941-7.178q-2.417,9.377-13.843,46.362Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.858,121.977h-22.7V33.794h-29.077V14.9h80.859v18.9h-29.077Z",
    style: {
      fill: "#05b758"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsiderThreat);
export default __webpack_public_path__ + "static/media/Insider-Threat.502cab696e8c7ea05e96c5ac79cc8a4f.svg";
export { ForwardRef as ReactComponent };